import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { translateFieldError } from '@/lib/i18n/translateFieldError';

interface Props {
    type: string;
    name: string;
    placeholder?: string;
    label?: string;
    value?: string;
    className?: string;
    className2?: string;
    error?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormInput = ({ type, name, placeholder, label, className, className2, error, ...props }: Props) => {
    const { t } = useTranslation();
    const errorMessage = translateFieldError(error, name, t);
    const inputId = `${name}-${useId()}`;

    return (
        <div className={className}>
            <label
                htmlFor={inputId}
                className={`block mb-1 md:text-[16px] text-[14px] font-medium text-primery-blue-900 ${className2}`}
            >
                {label}
            </label>
            <input
                id={inputId}
                type={type}
                name={name}
                className={`w-full p-3 rounded-lg border dark:bg-[#0D0D0D] md:text-[14px] text-[12px] text-gray-600 dark:text-[#3B3B3B] ${
                    errorMessage
                        ? 'border-red-500 focus:border-red-500 focus:ring-red-200'
                        : 'border-[#E8E7EA] hover:border-[#d9d8db] focus:border-primery-blue-900 focus:ring-primery-blue-200'
                } focus:outline-none focus:ring-2 transition-colors`}
                placeholder={placeholder}
                {...props}
            />
            {errorMessage && <p className="mt-1 text-sm text-red-600">{errorMessage}</p>}
        </div>
    );
};

export default FormInput;
